<template>
    <div class="video-lists">
        <Header hideAll noAuth border></Header>
        <BrowserAlert></BrowserAlert>
        <div class="list">
            <video v-show="currentVideo.m3u8frozenType === 'Normal' || currentVideo.m3u8frozenType === 'Unfrozen'" class="video-list video-js vjs-default-skin  vjs-big-play-centered" id="example_video_1"
                controls="controls" autoplay="autoplay"
                x-webkit-airplay="true" x5-video-player-fullscreen="true"
                preload="auto" playsinline="true" webkit-playsinline
                x5-video-player-typ="h5">
            </video >
          <div v-show="currentVideo.m3u8frozenType === 'Frozen' || currentVideo.m3u8frozenType === 'Unfreezing'" class="video-list video-js vjs-default-skin  vjs-big-play-centered" style="display:flex;justify-content: center; align-items: center;font-size:20px;">
            正在加载回放，请1分钟后刷新页面重试
          </div>
            <div class="right-part" v-if="videos.length">
                <div class="single" v-for="(item, index) in videos" @click="changeVideo(index)">
                    <div class="info">
                        <p>开始录制时间：</p>
                        <p>{{item.beginTime}}</p>
                    </div>
                    <el-button type="text" v-if="!item.downloadStatus" @click.stop="wantToDownload(item)">申请下载</el-button>
                    <a class="success" download="file" target="_blank" v-else :href="item.downloadOssUrl">下载</a>
                    <!-- <el-button type="text" class="success" v-else @click.stop="download2(item, index)">下载</el-button> -->
                    <el-progress type="circle" v-if="progress[index]" :stroke-width="2" :width="30" :status="progress[index] == 100 ? 'success':'warning'" :percentage="progress[index]"></el-progress>
                </div>
                <!-- <a class="link" target="blank" :href="helpUrl">帮助中心</a> -->
                <el-tooltip class="item" effect="dark" content="由于录制格式不同于播放格式，无法直接使用播放器播放，需要我们帮您在后台进行格式转换后再下载" placement="top-start">
                    <div class="help"><i class="el-icon-warning-outline"></i>下载说明</div>
                </el-tooltip>
            </div>
            <div class="right-part" v-else>
                <div class="single">
                    <div class="info">
                        <p>暂无视频</p>
                    </div>
                </div>
                <!-- <a class="link" target="blank" :href="helpUrl">帮助中心</a> -->
            </div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/Header'
import toolkit from "@/util/toolkit.js";
import config from "@/util/config";
import BrowserAlert from "@/components/BrowserAlert"
export default {
    components: {
        Header, BrowserAlert
    },
    data(){
        return{
            player:{},
            videos: [],
            currentVideo: '',
            query:{},
            helpUrl: config.helpUrl,
            progress: []
        }
    },
    created(){
        this.query = this.$route.query
        let interview_id = this.query.interview_id ? this.query.interview_id : ''
        let code = this.query.code ? this.query.code : ''
        let cid = this.query.cid ? this.query.cid : ''
        this.log('enterVideoReplay', `进入视频回看页面,interviewId:${interview_id},code:${code},cid:${cid}`)
    },
    mounted(){
        let that = this
        this.fetchVideo().then(res => {
            that.player = videojs('example_video_1',{
                muted: false,
                controls : true,      
                height:600, 
                width:600,
                loop : true,
                sources: that.videos
                // 更多配置.....
            }); 
        })
    },
    methods:{
        fetchVideo(){
            let query = this.query
            return new Promise((resolve, reject) => {
                toolkit.post(`/interview/video/getRecord?interviewId=${query.interview_id}&appCode=${query.app_code}&code=${query.code}`, {}).then(res => {
                    if(res.code == 0){
                        this.videos = res.data
                        this.currentVideo = this.videos[0]
                      console.log(this.currentVideo)
                        this.videos.forEach(val => {
                            val.src = val.url,
                            val.type = 'application/x-mpegURL'
                          //val.m3u8frozenType = "Unfreezing"
                        })
                        resolve()
                    } else{
                        this.$message.error(res.message)
                    }
                })
            })
        },
        changeVideo(index){
          console.log(this.videos[index])
            let that = this
            that.player.src({
                type: 'application/x-mpegURL',
                src: this.videos[index].url
            })
            this.player.play()
        },
        // 直接打开
        download1(item){
            window.open(item.downloadOssUrl)
        },
        // 获取数据流下载
        download2(item, index){
            this.progress[index] = 0
            this.progressDownLoad({
                url: item.downloadOssUrl, 
                filename: item.downloadOssUrl, 
                progress: progress =>{
                    let i = parseInt(progress.loaded*100/progress.total)
                    this.progress[index] = i
                    this.$forceUpdate()
                }, 
                success: res => {
                    console.log(res, 'res')
                }
            })
        },
        // iframe下载
        download3(item){
            let url = item.downloadOssUrl
            let elem = document.createElement('iframe');
            elem.src = url;
            elem.style.display = 'none';
            document.body.appendChild(elem);
        },

        wantToDownload(item){
            this.log('clickDownloadBotton', `点击视频回放页面申请下载按钮,recordId: ${item.recordId}`)
            toolkit.post('/interview/video/download', {
                recordId: item.recordId
            }).then(res => {
                if(res.code == 0){
                    this.$notify.success({
                        title: 'success',
                        message: '回放视频正在转码中，请您耐心等待10-30分钟，然后即可下载并保存到本地',
                        duration: 3000
                    })
                }else{
                    this.$message.error(res.message)
                }
            })
        },

        progressDownLoad({url,filename,params,progress,success}){
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            //监听进度事件
            xhr.addEventListener("progress", function (evt) {
                if(progress) try{ progress(evt); }catch(e){}
            }, false);

            xhr.responseType = "blob";
            xhr.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=UTF-8");
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    if (typeof window.chrome !== 'undefined') {
                        // Chrome version
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(xhr.response);
                        link.download = filename;
                        link.click();
                    } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        // IE version
                        var blob = new Blob([xhr.response], { type: 'application/force-download' });
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        // Firefox version
                        var file = new File([xhr.response], filename, { type: 'application/force-download' });
                        window.open(URL.createObjectURL(file));
                    }
                    if(success) try{ success.call(xhr); }catch(e){}
                }
            };
            // FormData
            //var formData = new FormData();
            var paramsStr = '';
            if(params) for (var key in params) paramsStr += '&'+key+'='+params[key];
            if(paramsStr) paramsStr = paramsStr.substring(1);

            xhr.send(paramsStr);
        },
        log(action, info, extraData){
            return toolkit.logToBackend(action,info, extraData)
        },
    }
}
</script>
<style scoped lang="scss">
.video-lists {
    height: 100vh;
}
.video-lists  .logo{
	display: flex;
	justify-content: space-between;
	align-items: center;
    padding: 0 50px;
    height: 80px;
    width: 100%;
    box-sizing: border-box;
}
.video-lists  .logo .left{
	display: flex;
	align-items: center;
}
.video-lists  .logo .left img{
	height: 30px;
	width: auto;
}
.video-lists  .logo .left .title{
	font-size: 20px;
	color: #333;
	font-weight: bold;
} 
*{
    box-sizing: border-box;
}
    button:active,button:focus,button:visited{
        outline: none;
    }
    .list{
        width: 100%;
        height: calc(100vh - 80px);
        display: flex;
    }
    .video-list{
        width: calc(100% - 300px);
        height: calc(100% - 40px);
        margin: 20px;
    }
    .right-part{
        width: 260px;
        flex-shrink: 0;
        height: calc(100% - 40px);
        overflow: auto;
        margin: 20px 0px;
        margin-left: 0;
        margin-right: 20px;        
    }
    .right-part .link{
        text-decoration: none;
        color: #5272FF;
        cursor: pointer;
        display: inline-block;
        width: 100%;
        text-align: center;
        margin-top: 10px;
        font-size: 15px;
    }
    .right-part .link:hover{
        color: #627FFF;
    }
    .right-part .single {
        background: rgba(0,0,0,0.4);
        height: 60px;
        width: 260px;
        border: 1px solid #ffffff;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        cursor: pointer;
    }
    .single .info{
        color: #fff;
        font-size: 12px;
        text-align: center;
    }
    .single .link{
        text-decoration: none;
        font-size: 14px;
        color: #5272FF;
        display: inline-block;
        width: unset;
    }
    .single .success{
        color: #27BA9C;
        text-decoration: none;
        &:hover{
            color: #4DBF2F;
        }
    }
    .single .link:hover{
        color: #627FFF;
    }
    .right-part .single:hover{
        border: 1px solid #27BA9C;
    }
    .right-part{
        .help{
            cursor: pointer;
            display: flex;
            height: 30px;
	        color: #333;
            font-size: 13px;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            width: 100px;
            margin-left: 50%;
            transform: translate(-50%, 0);
        }
        .single{

        }
    }
</style>



// WEBPACK FOOTER //
// src/content/play.vue